import { ImportData } from "../../../Components/Pricings/Offers/ImportData";

export default function Import(){
    return(
        <ImportData/>
    )
}